"use client";

import { Instagram, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-5 w-24 bg-muted animate-pulse rounded-md" />
        <li className="h-5 w-20 bg-muted animate-pulse rounded-md" />
        <li className="h-5 w-28 bg-muted animate-pulse rounded-md" />
        <li className="h-5 w-16 bg-muted animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default text-base text-foreground/80 hover:text-primary transition-colors duration-200 relative group inline-block">
            {item.label}
            <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-primary group-hover:w-full transition-all duration-300" />
          </Link>
        </li>)}
    </ul>;
}
const shopLinks = [{
  label: "Class Hub",
  to: "/Class2AHubPage"
}, {
  label: "Parent Toolbox",
  to: "/ParentToolboxPage"
}, {
  label: "Our Journey",
  to: "/OurJourneyPage"
}, {
  label: "Contact",
  to: "#"
}];
const companyLinks = [{
  label: "About Class 2A",
  to: "/OurJourneyPage"
}, {
  label: "Class News",
  to: "#"
}, {
  label: "Visit Us",
  to: "#"
}, {
  label: "Staff Directory",
  to: "#"
}];
const helpLinks = [{
  label: "Lunch Menu",
  to: "#"
}, {
  label: "Homework",
  to: "#"
}, {
  label: "Policies",
  to: "#"
}, {
  label: "Permission Slips",
  to: "#"
}];
const socialLinks = [{
  Icon: Instagram,
  label: "Instagram",
  to: "#"
}, {
  Icon: Youtube,
  label: "YouTube",
  to: "#"
}];
const tickerItems = ["LEARNING THROUGH PLAY", "FIELD TRIP THIS FRIDAY", "EST. 2024", "CREATIVITY FIRST", "GROWING TOGETHER"];
export default function ClassroomFooter() {
  return <section data-section-id="1475" id="classroom-footer" className="relative bg-white text-foreground overflow-hidden">
      {}
      <div className="relative w-full h-1.5 bg-sky-100">
        <div className="absolute inset-0 flex items-center justify-center gap-3">
          <span className="block size-2 rounded-lg bg-primary" />
          <span className="block size-2 rounded-lg bg-primary" />
          <span className="block size-2 rounded-lg bg-primary" />
        </div>
      </div>

      {}
      <div className="relative bg-white border-b border-border overflow-hidden">
        <div className="flex whitespace-nowrap py-3 animate-[marquee_38s_linear_infinite] hover:[animation-play-state:paused]">
          {[...tickerItems, ...tickerItems, ...tickerItems].map((item, i) => <div data-index={i} key={i} className="flex items-center font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 px-6">
              <span className="mr-6 text-primary">◉</span>
              {item}
            </div>)}
        </div>
        <style>{`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-33.333%); }
          }
        `}</style>
      </div>

      {}
      <div className="max-w-[1360px] mx-auto px-6 md:px-14 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 md:gap-12">
          {}
          <div className="lg:col-span-5 space-y-6">
            <Link to="/" aria-label="Class 2A home" className="inline-block">
              <WvcLogo className="h-12 w-auto text-foreground" />
            </Link>
            <p className="font-default text-lg text-foreground/70 leading-relaxed max-w-sm">
              A bright, creative space where every student shines.
            </p>

            {}
            <div className="inline-block">
              <div className="relative -rotate-[6deg] inline-flex items-center justify-center px-5 py-2 bg-primary rounded-lg shadow-md">
                <span className="font-mono text-xs tracking-[0.18em] uppercase text-foreground font-semibold">
                  Class 2A · Learning Lab
                </span>
              </div>
            </div>

            <div className="pt-2">
              <div className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 mb-4">
                Follow Our Progress
              </div>
              <div className="flex items-center gap-3">
                {socialLinks.map((social, i) => {
                const Icon = social.Icon;
                return <Link to={social.to} key={social.label} data-index={i} aria-label={social.label} className="size-11 rounded-lg border border-border flex items-center justify-center text-foreground hover:bg-primary hover:border-primary hover:text-foreground transition-all duration-200 hover:-rotate-[6deg]">
                      <Icon className="size-5" strokeWidth={1.75} />
                    </Link>;
              })}
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-3">
            <div className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 mb-5">
              Navigation
            </div>
            <MenuProvider menu_id="3" className="footer-shop-menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-2">
            <div className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 mb-5">
              About
            </div>
            <ul className="space-y-3">
              {companyLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="font-default text-base text-foreground/80 hover:text-primary transition-colors duration-200 relative group inline-block">
                    {link.label}
                    <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-primary group-hover:w-full transition-all duration-300" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-2">
            <div className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 mb-5">
              Resources
            </div>
            <ul className="space-y-3">
              {helpLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="font-default text-base text-foreground/80 hover:text-primary transition-colors duration-200 relative group inline-block">
                    {link.label}
                    <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-primary group-hover:w-full transition-all duration-300" />
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-14 pt-8 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <div className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 mb-2">
                Location
              </div>
              <p className="font-default text-sm text-foreground/75 leading-relaxed">
                Room 2A, Primary School Building, Education Lane
              </p>
            </div>
            <div>
              <div className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 mb-2">
                Email
              </div>
              <Link to="mailto:hello@class2a.edu" className="font-default text-sm text-foreground/75 hover:text-primary transition-colors">
                hello@class2a.edu
              </Link>
            </div>
            <div>
              <div className="font-mono text-xs tracking-[0.18em] uppercase text-foreground/60 mb-2">
                Office
              </div>
              <Link to="tel:+15551234567" className="font-default text-sm text-foreground/75 hover:text-primary transition-colors">
                (555) 123-4567
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-border my-8" />

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-xs tracking-[0.08em] text-foreground/50">
            © {new Date().getFullYear()} Class 2A. All rights reserved.
          </p>

          {}
          <div className="relative size-12" aria-hidden="true">
            <svg viewBox="0 0 48 48" className="w-full h-full">
              <g stroke="var(--primary)" strokeWidth="1.75" strokeLinecap="round" fill="none">
                <line x1="24" y1="48" x2="24" y2="36" />
                <line x1="10" y1="48" x2="14" y2="38" />
                <line x1="38" y1="48" x2="34" y2="38" />
                <line x1="2" y1="42" x2="10" y2="34" />
                <line x1="46" y1="42" x2="38" y2="34" />
                <line x1="0" y1="34" x2="8" y2="30" />
                <line x1="48" y1="34" x2="40" y2="30" />
              </g>
              <path d="M 6 48 A 18 18 0 0 1 42 48 Z" fill="var(--primary)" opacity="0.9" />
            </svg>
          </div>
        </div>
      </div>
    </section>;
}